import Url from 'urlinator/Url';
export const getValidatedCompanyDomain = signupDataCompanyDomain => {
  const domainUrl = new Url(signupDataCompanyDomain);
  return domainUrl.hostname;
};